export default { sha: '6677a002117233f75c7338e86f29b119dd4d41b2', buildNumber: 'undefined' }
